module.exports = __webpack_public_path__ + "static/media/phone.eddafa10.svg";